import colors from 'assets/theme/base/colors';
import pxToRem from 'assets/theme/function/px-to-rem';
import { breakpoints } from 'assets/theme/base/breakpoints';

const buttonText = {
    base: {
        backgroundColor: 'transparent',

        '& .MuiButton-endIcon': {
            [breakpoints.down('md')]: {
                marginLeft: pxToRem(3),
            },

            '& .MuiSvgIcon-root': {
                fontSize: pxToRem(25),

                [breakpoints.down('md')]: {
                    fontSize: pxToRem(18),
                },
            },
        },
    },

    small: {},

    large: {},

    primary: {
        color: colors.common.white,
    },
    success: {},

    secondary: {},
};

export default buttonText;
